<template>

  <div class="country-selector-container">

    <div class="content"
         :class="toggled ? 'toggled' : 'untoggled'"
         tabindex="-1"
         @blur="filterBoxBlurred"
         @click="toggleFilters">
      <img class="flag" alt="flag" v-if="$country" :src="`../../../static/icons/${$country}.png`"/>
    </div>

    <transition name="options-transition">
      <div class="options" v-if="toggled">
        <div class="options-item" v-for="option in options" v-if="option !== selected" :key="option" @click="select(option)">
          <img class="flag" alt="flag" :src="`../../../static/icons/${option}.png`"/>
        </div>
      </div>
    </transition>

  </div>

</template>

<script>

import Vue from 'vue'

export default {
  name: 'CountrySelector',
  data () {
    return {
      options: ['FR', 'US'],
      selected: null,

      toggled: false
    }
  },
  mounted () {
    this.selected = this.$country
  },
  methods: {
    toggleFilters () {
      this.toggled = !this.toggled
    },
    select (option) {
      this.toggled = false
      this.selected = option

      let localeRegion = localStorage.getItem('localeRegion')
      let country = localStorage.getItem('country')

      if (localeRegion) {
        localStorage.removeItem('localeRegion')
      }
      if (country) {
        localStorage.removeItem('country')
      }

      if (option === 'FR') {
        localStorage.setItem('localeRegion', 'fr')
      } else {
        localStorage.setItem('localeRegion', 'en')
      }
      localStorage.setItem('country', option)

      Vue.prototype.$localeRegion = localStorage.getItem('localeRegion')
      Vue.prototype.$country = option

      this.$router.go(0)
    },
    filterBoxBlurred () {
      setTimeout(() => {
        this.toggled = false
      }, 250)
    }
  }
}

</script>

<style lang="scss" scoped>

.country-selector-container {
  outline: none;
  position: relative;
}

.content {
  outline: none;
  height: 42px;
  padding: 0 12px;
  cursor: pointer;

  display: grid;

  &.toggled {
    border-top: 1px solid white; // so the text inside won't move
    border-bottom: 1px solid #f5f5f5;
  }
  &:hover {
    background-color: #d6d6d6;
  }
}

.flag {
  height: 30px;
  align-self: center;
  justify-self: center;
}

.options {
  width: 100%;
  max-height: 240px;
  overflow-y: scroll;
  position: absolute;
  background-color: #f5f5f5;
  z-index: 2;
  box-shadow: 5px 5px 5px lightgrey;
}

.options-item {
  height: 42px;
  cursor: pointer;

  display: grid;

  &:hover {
    background-color: #d6d6d6;
  }
}

.options-transition-enter-active, .options-transition-leave-active {
  transition: all .25s;
}

.options-transition-enter, .options-transition-leave-to {
  max-height: 0;
}

.options-transition-leave, .options-transition-enter-to {
  max-height: 240px;
}

</style>



// WEBPACK FOOTER //
// src/components/CountrySelector.vue